import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import OutlinedInput from '@mui/material/OutlinedInput';

import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import { useState } from 'react';
import { getAPI } from 'src/utils/api';
import { useNotify } from 'src/context/ContextNotify';
import { getToken } from 'src/utils/auth';

const DialogScanBarcode = (props: any) => {
  const notifyContext = useNotify();
  const [data, setData] = useState('');
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setData(event.target.value);
  };

  const handleClose = () => {
    setData('')
    props.handleClose()
  }

  const handleSearch = () => {
      
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    getAPI(`/inventory/scan/${data}?token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          console.log(res.data);
          props.handleConfirm(res.data);
        } else {
          notifyContext.setNotifyMessage({
            show: true,
            message: res.msg || 'Failed to post data',
            type: 'error',
          });
        }
      })
      .finally(() => {});
  };
  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='scroll-dialog-title'>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography fontSize={'20px'} fontWeight={500}>
            バーコードスキャン
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: '500px' }}>
        <Stack direction={'row'} spacing={'20px'} alignItems={'center'}>
          <OutlinedInput
            placeholder={'バーコードを入力'}
            sx={{
              fontSize: '14px',
              my: '8px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#BDBDBD',
              },
              '& .MuiInputBase-input': { padding: '8px 14px' },
              '& input::placeholder': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#CCD1D9',
                opacity: 1,
              },
              backgroundColor: 'primary.light',
              width: '100%',
            }}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='patientid'
            value={data}
            onChange={(event) => handleInputChange(event)}
          />
          <BtnGradient text='検索' handleButtonClick={handleSearch} />
        </Stack>
        <Divider sx={{ my: '20px' }}>または</Divider>
        <Typography fontWeight={500} textAlign={'center'}>
          バーコードをカメラにおさめてください
        </Typography>
        <BarcodeScannerComponent
          width={450}
          height={450}
          onUpdate={(err, result: any) => {
            if (result) setData(result.text);
            // else {
            //   if (!data) {
            //     setData('Not Found 2222 ');
            //   }
            // }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: '20px', pt: '0' }}>
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogScanBarcode;
